import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/rocket.svg'
import _imports_1 from '@/assets/images/spin.svg'


const _hoisted_1 = { class: "grad" }
const _hoisted_2 = { class: "pt-10 flex flex-col justify-center py-12 sm:px-6 lg:px-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex-row flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-12 w-12 mylog rounded-2xl",
    src: _imports_0,
    alt: "Workflow"
  })
], -1)
const _hoisted_4 = { class: "flex-row flex justify-center mt-10 text-cool" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, "/", -1)
const _hoisted_6 = { class: "mt-2 sm:mx-auto sm:w-full sm:max-w-md" }
const _hoisted_7 = { class: "py-8 px-4 shadow sm:rounded-lg sm:px-10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-sm font-medium text-cool"
}, " Email address ", -1)
const _hoisted_9 = { class: "mt-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "block text-sm font-medium text-cool"
}, " Password ", -1)
const _hoisted_11 = { class: "mt-1" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "block text-sm font-medium text-cool"
}, " Repeat password ", -1)
const _hoisted_14 = { class: "mt-1" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center justify-between\"><div class=\"flex items-center\"><input id=\"remember_me\" name=\"remember_me\" type=\"checkbox\" class=\"h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded\"><label for=\"remember_me\" class=\"ml-2 block text-sm text-cool\"> Remember me </label></div><div class=\"text-sm\"><a href=\"#\" class=\"font-medium text-indigo-600 hover:text-indigo-500\"> Forgot your password? </a></div></div>", 1)
const _hoisted_16 = {
  key: 0,
  class: "w-5 mr-2.5 animate-spin",
  src: _imports_1,
  alt: "Workflow"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, "Sign in", -1)
const _hoisted_18 = {
  key: 0,
  class: "w-5 mr-2.5 animate-spin",
  src: _imports_1,
  alt: "Workflow"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.type = 'login')),
          class: _normalizeClass([{'underline' : _ctx.type == 'login'}, "px-2 cursor-pointer"])
        }, "Login", 2),
        _hoisted_5,
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.type = 'register')),
          class: _normalizeClass([{ 'underline': _ctx.type == 'register' }, "px-2 cursor-pointer"])
        }, " Register ", 2)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("form", {
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
            class: "space-y-6"
          }, [
            _createElementVNode("div", null, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  id: "email",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
                  name: "email",
                  type: "email",
                  autocomplete: "email",
                  required: "",
                  class: "bg-transparent text-white appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  id: "password",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pwd) = $event)),
                  name: "password",
                  type: "password",
                  autocomplete: "current-password",
                  required: "",
                  class: "bg-transparent text-white appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                }, null, 512), [
                  [_vModelText, _ctx.pwd]
                ])
              ])
            ]),
            (_ctx.type == 'register')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      id: "password",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pwd2) = $event)),
                      name: "password",
                      type: "password",
                      autocomplete: "current-password",
                      required: "",
                      class: "bg-transparent text-white appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    }, null, 512), [
                      [_vModelText, _ctx.pwd2]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _hoisted_15,
            _createElementVNode("div", null, [
              (_ctx.type == 'login')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.signin && _ctx.signin(...args))),
                    type: "submit",
                    class: "w-full flex items-center justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  }, [
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                      : _createCommentVNode("", true),
                    _hoisted_17
                  ]))
                : _createCommentVNode("", true),
              (_ctx.type == 'register')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args))),
                    type: "submit",
                    class: "w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  }, [
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                      : _createCommentVNode("", true),
                    _createTextVNode(" Register ")
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}